import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useIntl } from 'react-intl';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { type ClientsWay, DEFAULT_CLIENTS_WAY } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const ClientsWayInput = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const {
    currentUser: { userType },
  } = useUserContext();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const isInternalSales = userType === 'Internal Sales';

  const { formatMessage } = useIntl();
  const clientsWay = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'clientsWay'));
  const currencyPair = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'currencyPair'));
  const [currency1] = currencyPair?.split('/') ?? [];

  const handleChangeClientWay = (value: ClientsWay) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Clients way changed', isDefined(value) ? value : 'cleared');

    return check({
      clientsWay: value,
    });
  };

  function formatClientsWay(value: ClientsWay): string {
    return formatMessage(
      {
        id: `targetAccumulator.form.clientsWay.${value}`,
      },
      { currency: currency1 },
    );
  }

  const selectedValue = clientsWay ?? DEFAULT_CLIENTS_WAY;

  return (
    <FormField formattedMessageId="targetAccumulator.form.clientsWay" formattedMessageValues={{ isInternalSales }}>
      <form>
        <div className="d-flex flex-column w-100">
          <div className="btn-group btn-group-toggle btn-group-sm">
            <input
              className="btn-check"
              type="radio"
              name="clientsWay"
              id="Buy"
              value="Buy"
              checked={selectedValue === 'Buy'}
              onChange={() => handleChangeClientWay('Buy')}
            />
            <label
              className="btn btn-toggle-primary w-50"
              htmlFor="Buy"
              data-e2e="way-Buy-label"
              data-e2e-way-type={selectedValue === 'Buy' ? 'active' : undefined}
            >
              {formatClientsWay('Buy')}
            </label>
            <input
              className="btn-check"
              type="radio"
              name="clientsWay"
              id="Sell"
              value="Sell"
              checked={selectedValue === 'Sell'}
              onChange={() => handleChangeClientWay('Sell')}
            />
            <label
              className="btn btn-toggle-primary w-50"
              htmlFor="Sell"
              data-e2e="way-Sell-label"
              data-e2e-way-type={selectedValue === 'Sell' ? 'active' : undefined}
            >
              {formatClientsWay('Sell')}
            </label>
          </div>
        </div>
      </form>
    </FormField>
  );
};
